import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  public sendPageView(path: string): void {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', { page_path: path });
  }

  public sendEvent(name: string, params: any = {}) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
  }
}
